import Error from "./Error.page";

export default Error;
